import React, {useState, useCallback} from 'react';
import PropTypes from 'prop-types';
import {i18n} from 'core/localization';

import {MultiToggle} from "./form";

export const timePeriodItems = {
	'LASTHOUR': i18n('Hour'),
	'LASTDAY': i18n('24h'),
	'LAST7DAYS': i18n('7d'),
	'LAST30DAYS': i18n('30d')
};

export const timePeriodItemsWithCustom = {
	...timePeriodItems,
	'CUSTOM': i18n('Custom')
};

export let timePeriodMultiToggle = rawProps => {
	const props = { includeCustom: true, ...rawProps };
	const [value, setValue] = useState(props.value || 'LASTHOUR');

	const resetCallback = useCallback(() => {
		setValue('CUSTOM')
	}, [setValue]);

	if (props.setResetCallback) {
		props.setResetCallback(resetCallback);
	}

	return (
		<MultiToggle items={props.includeCustom ? timePeriodItemsWithCustom : timePeriodItems}
		             onChange={period => {setValue(period), props.onChange(period)}}
		             value={value}/>
	);
}

export default timePeriodMultiToggle;

timePeriodMultiToggle.propTypes = {
	includeCustom: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOf(['LASTHOUR', 'LASTDAY', 'LAST7DAYS', 'LAST30DAYS', 'CUSTOM']),
	setResetCallback: PropTypes.func
}


